<template>
	<div class="content">

    <div class="row animated fadeIn">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item"  @click.prevent="onChange('userList')">
                <a class="nav-link active show" id="active-tab"
                   data-toggle="tab" href="#userList" role="tab" aria-controls="up">
                  Customers
                </a>
              </li>
              <li class="nav-item" @click.prevent="onChange('adminList')">
                <a class="nav-link" id="backup-tab"
                   data-toggle="tab" href="#adminList" role="tab" aria-controls="up">
                  Admins
                </a>
              </li>
              <li class="nav-item" @click.prevent="onChange('addNewCustomer')">
                <a class="nav-link"  data-toggle="tab"
                   href="#addNewCustomer" role="tab" aria-controls="down">
                  Add Customer
                </a>
              </li>
              <li class="nav-item" @click.prevent="onChange('customerAudit')">
                <a class="nav-link"  data-toggle="tab"
                   href="#customerAudit" role="tab" aria-controls="down">
                  Customer Plans Audit
                </a>
              </li>
            </ul>
					</div>
					<div class="card-body">
            <Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
            <div class="tab-content customer-table">
              <div id="userList" class="tab-pane active show"  v-if="selected === 'userList'">
                <UserList />
              </div>
              <div id="adminList" class="tab-pane fade" v-else-if="selected === 'adminList'">
                <AdminList/>
              </div>
              <div id="addNewCustomer" class="tab-pane fade" v-else-if="selected === 'addNewCustomer'">
                <createUser/>
              </div>
              <div id="customerAudit" class="tab-pane fade"  v-else-if="selected === 'customerAudit'">
               <customer-audit-list/>
              </div>
            </div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>

export default {
	name: "createdUserList",
  components: {
		Alert: () =>
      import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
    UserList: () =>
      import(/* webpackChunkName: "userList" */ "../../../components/Admin/EditUser/CustomerList/CustomerList.vue"),
    AdminList: () =>
      import(/* webpackChunkName: "userList" */ "../../../components/Admin/EditUser/AdminList/AdminList.vue"),
    createUser: () =>
      import(/* webpackChunkName: "userList" */ "../../../views/admin/CreateUser/CreateUserForm.vue"),
    customerAuditList: ()=>
        import( "../../../components/Admin/EditUser/CustomerAudit/index.vue")
	},
  data() {
    return {
      selected: 'userList'
    }
  },
	computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
		},
		hasAllCustomer() {
			return this.$store.getters["customer/hasAllCustomers"]
		}
  },
  methods: {
  onChange(tab){
    this.selected = tab
  }
  }
};
</script>
<style scoped>
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}
</style>

